import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { LayoutContainer } from '@netiva/classifieds-ui';
import { useAppSelector } from '@/store';
import { PlatformLogo } from '@/components/ui';

export type LayoutProps = PropsWithChildren<{
  onClose: VoidFunction;
}>;

export const Layout: FC<LayoutProps> = ({ onClose, children }) => {
  const { t } = useTranslation();
  const { pageTitle, platforms } = useAppSelector((state) => state.global);
  const { platform } = useAppSelector((state) => state.ad);
  const platformName = platforms.find((p) => p.key === platform)?.name;
  return (
    <Box bgColor="surface" minHeight="100vh">
      <LayoutContainer
        maxWidth={{ base: 'layout.sm', md: 'layout.md', lg: 'layout.lg', xl: 'layout.xl', '2xl': 'layout.2xl' }}
        padding={{ base: 0, md: 4 }}
        py={[0, 14]}
      >
        <Flex
          justify="space-between"
          align="center"
          bgColor="dark"
          boxShadow="default"
          px={[4, 6, 8]}
          py={4}
          color="neutral.50"
        >
          <Flex align="center" gap={2}>
            <Heading as="h1" size="md" color="white">
              {pageTitle}
            </Heading>
          </Flex>
          {platformName && <PlatformLogo platformKey={platform} platformName={platformName} />}
          <Button variant="outline" size="sm" onClick={onClose}>
            {t('ui.buttons.close')}
          </Button>
        </Flex>
        <Box boxShadow="default">{children}</Box>
      </LayoutContainer>
    </Box>
  );
};
